import Checkbox from './Checkbox';

export default Checkbox;



// WEBPACK FOOTER //
// ./ext/checkbox/src/index.js